<template>
  <vetster-slide-over ref="partnerReviewsSlideOver">
    <template #header>
      <vetster-slide-over-common-heading
        :show-close="false"
        show-back
        @back="back"
      >
        <div class="text-2xl font-title text-neutral-900 font-medium">
          <vetster-reviews-count :partner="partner" />
        </div>
      </vetster-slide-over-common-heading>
    </template>

    <template #content>
      <vetster-px-review-list
        max-height="h-screen"
        class="px-standard"
        :partner="partner"
      />
    </template>
  </vetster-slide-over>
</template>

<script>
import VetsterPxReviewList from '@/brand-components/VetsterPxReviewList';
import VetsterReviewsCount from '@/brand-components/VetsterReviewsCount';
import VetsterSlideOver from '@/brand-components/VetsterSlideOver';
import VetsterSlideOverCommonHeading from '@/brand-components/VetsterSlideOverCommonHeading';
import ParseErrors from '@/mixins/ParseErrors';

export default {
  name: 'VetsterPartnerReviews',

  components: {
    VetsterPxReviewList,
    VetsterReviewsCount,
    VetsterSlideOver,
    VetsterSlideOverCommonHeading,
  },

  mixins: [ParseErrors],

  props: {
    partner: {
      type: Object,
      required: true,
    },
  },

  methods: {
    back() {
      this.$refs.partnerReviewsSlideOver.close();
    },
    open() {
      this.$refs.partnerReviewsSlideOver.open();
    },
  },
};
</script>
